<ln-ln-pages-armor>
  <section body class="bg-beige bg-opacity-10">
    <!--    volver button-->
    <section>
      <div
        class="sm:border-t-opacity-10 min-h-[60px] sm:border-t-[2.5px] sm:border-t-beige sm:shadow-[0px_-2px_5px_0px_rgba(0,0,0,0.10)]">
        <div class="mx-auto flex max-w-[1440px] flex-col justify-center">
          <button
            (click)="navigateBack()"
            class="ml-[31px] flex max-w-fit items-center pt-[22px] transition duration-100 hover:scale-110 sm:ml-[116px] sm:pt-[15px]">
            <ln-ln-arrow-back-svg-icon [class]="'h-[24px] w-[p4px]'"></ln-ln-arrow-back-svg-icon>
            <span class="ml-[6px] hidden font-['Roboto'] text-base font-normal text-cafe sm:block">{{
              'buttons.goBack' | transloco
            }}</span>
          </button>
        </div>
      </div>
    </section>
    <div class="mx-auto flex flex-col">
      <!--    header-->
      <div class="flex flex-row">
        @if (artisanData() !== undefined) {
          <ln-ln-image-frame
            [src]="artisanData()!.urlImgBanner"
            [alt]="'imagesAlt.artisan' | transloco"
            [class]="'h-[227px] w-[100dvw] object-cover sm:h-[605px]'"></ln-ln-image-frame>
        }
      </div>
    </div>
    @if (artisanData() !== undefined) {
      <section class="mx-auto flex max-w-[1440px] flex-col">
        <!--      body-->
        <section class="pb-[30px] pt-[30px] sm:pb-[78px] sm:pt-[53px]">
          <div class="mx-[35px] flex flex-col space-y-[30px] sm:mx-[120px]">
            <ln-topic-paragraph [tittle]="artisanData()!.nombre" [text]="artisanData()!.traducciones[0].descripcion">
            </ln-topic-paragraph>

            @for (sections of artisanData()!.secciones; track sections) {
              @for (parragraph of sections.parrafos; track parragraph) {
                <ln-topic-paragraph [tittle]="parragraph.subtitulo" [text]="parragraph.texto"> </ln-topic-paragraph>
              }
            }
          </div>

          <!--        body images-->
          <section>
            <div
              class="mx-[35px] mt-[30px] flex flex-col space-y-[30px] sm:mx-[120px] sm:mt-[33px] sm:flex-row sm:space-x-[20px] sm:space-y-[0px]">
              <div class="w-full sm:w-1/2">
                @if (artisanData()!.urlImgPromo) {
                  <ln-ln-image-frame
                    [src]="artisanData()!.urlImgPromo"
                    alt="Imagen del producto"
                    [class]="'h-[440px] w-full object-cover'"></ln-ln-image-frame>
                }
              </div>
              <div class="w-full sm:w-1/2">
                @if (artisanData()!.urlImgPortada) {
                  <ln-ln-image-frame
                    [src]="artisanData()!.urlImgPortada"
                    [alt]="'imagesAlt.product' | transloco"
                    [class]="'h-[440px] w-full object-cover'"></ln-ln-image-frame>
                }
              </div>
            </div>
          </section>
        </section>
        <div class="flex items-center border-b-[2px] border-b-verde opacity-40 sm:mx-[68px]"></div>
      </section>
      <ln-ln-special-products
        [artisanName]="artisanData()!.nombre"
        [sellerId]="artisanData()!.id"></ln-ln-special-products>
    }
  </section>
</ln-ln-pages-armor>
